<template>
  <div :style="styles">
    <div 
      class="grid-x align-middle">
      <div class="cell shrink">
        <span v-html="$icons.get('spinner', 'xlarge spin')" style="padding-right:.4rem"></span>
      </div>
      <div class="cell auto">
        <h6 style="font-weight:normal">{{ label }}</h6>
      </div>
    </div>
  </div>
</template>

<script>
export default { 
  name: 'Loading',
  props: {
    label: {
      type: String,
      required: true
    },
    center: {
      type: Boolean
    }
  },
  computed: {
    styles () {
      let styles = {}
      if (this.center) {
        styles.display = 'inline-block'
        styles.margin = '0 auto'
      }
      return styles
    }
  }
}
</script>
